module.exports = __webpack_public_path__ + "static/aboutSculpture-ad6dd89f82f8c669ed7aa25bb0d74a3d.png";